import VueRouter from 'vue-router';

import { frontendURL } from '../helper/URLHelper';
import dashboard from './dashboard/dashboard.routes';
import store from '../store';
import { validateLoggedInRoutes } from '../helper/routeHelpers';
import AnalyticsHelper from '../helper/AnalyticsHelper';
import { buildPermissionsFromRouter } from '../helper/permissionsHelper';

const routes = [...dashboard.routes];

export const router = new VueRouter({ mode: 'history', routes });
export const routesWithPermissions = buildPermissionsFromRouter(routes);

export const validateAuthenticateRoutePermission = (to, next, { getters }) => {
  const { isLoggedIn, getCurrentUser: user } = getters;

  if (!isLoggedIn) {
    window.location = '/app/login';
    return '/app/login';
  }

  //if (
  //  (user.role === 'end_user_view_only' ||
  //    user.role === 'end_user_view_all' ||
  //    user.role === 'end_user_executive') &&
  //  to.name !== 'requests_conversation' &&
  //  to.name !== 'customer_list' &&
  //  to.name !== 'list_requests' &&
  //  to.name !== 'sla_reports' &&
  //  to.name !== 'account_overview_reports' &&
  //  to.name !== 'conversation_reports' &&
  //  to.name !== 'ticket_box' &&
  //  to.name !== 'list_organization' &&
  //  to.name !== 'profile_settings_index'
  //) {
  //  return next(frontendURL(`accounts/${user.account_id}/requests`));
  //}

  if (
    (user.role === 'end_user_view_only' ||
      user.role === 'end_user_view_all' ||
      user.role === 'end_user_executive') &&
    to.name !== 'requests_conversation' &&
    to.name !== 'customer_list' &&
    to.name !== 'list_requests' &&
    to.name !== 'sla_reports' &&
    to.name !== 'account_overview_reports' &&
    to.name !== 'conversation_reports' &&
    to.name !== 'ticket_box' &&
    to.name !== 'list_organization' &&
    to.name !== 'profile_settings_index'
  ) {
    console.log('va a redirecionar');
    window.location.href = 'https://soporte.roblelabs.cl/';
    return; // Ya no necesitas el next() porque estás saliendo del sitio
  }


  if (!to.name) {
    return next(frontendURL(`accounts/${user.account_id}/dashboard`));
  }

  const nextRoute = validateLoggedInRoutes(to, getters.getCurrentUser);
  return nextRoute ? next(frontendURL(nextRoute)) : next();
};

export const initalizeRouter = () => {
  const userAuthentication = store.dispatch('setUser');

  router.beforeEach((to, from, next) => {
    AnalyticsHelper.page(to.name || '', {
      path: to.path,
      name: to.name,
    });

    userAuthentication.then(() => {
      return validateAuthenticateRoutePermission(to, next, store);
    });
  });
};

export default router;
